/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable react/self-closing-comp */
/* eslint-disable max-len */
import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import {
    Box,
    Tab as MUITab,
    SwipeableDrawer,
    Tabs,
    withStyles,
    IconButton,
    makeStyles,
    Drawer,
} from '@material-ui/core';
import { useAtom } from 'jotai';
import { useQuery, useQueryClient } from 'react-query';
import { useHistory } from 'react-router';
import CommonModal from 'src/components/CommonModal';
import { RewardsEnrollErrorDialog } from 'src/components/EasyRewards';
import { IconStaplesRound } from 'src/components/Icons';
import PullToRefresh from 'src/components/PullToRefresh';
import Row from 'src/components/Row';
import { BackToTopFAB, Body, Button } from 'src/components/UI';
import {
    eventMetricsMap,
    useErTooltips,
    useEventsReporter,
    useGuestMode,
    useRouter,
    useStickyNotification,
    useStoreData,
    useUserInfo,
} from 'src/hooks';
import { useProductBrowseContext } from 'src/lib/contexts/product-browse-context';
import ROUTES from 'src/lib/routes';
import { isListEnabled } from 'src/lib/api-client/lists';
import { saveDigitalCoupon } from 'src/lib/api-client/wallet-activities';
import { SetSomniAppCookies } from 'src/lib/utils/app-utils';
import { useUserUpdateContext } from 'src/lib/contexts/user-update-context';
import { REWARDS_ENROLLMENT_ROUTES } from 'src/routers/routes';
import AlertMessage from 'src/screens/alert-message';
import {
    GET_COUPONS_QUERY_KEY,
    getCoupons,
    LoyaltyOffersQueryKey,
    useEnrollInRewardsMutation,
    useLoyaltyAccountDetailsQuery,
} from 'src/services/easyRewardsServices';
import { validateUserInfo } from 'src/utils/userUtils';
import BrandIframe from 'src/components/BrandIframe';
import { mergeClasses } from 'src/stylesheets/utils';
import IframeHeader from 'src/components/header';
import COLORS from 'src/lib/colors';
import { CancelRounded } from '@material-ui/icons';
import { useTabsUIStateContext } from 'src/lib/contexts/tabs-ui-state-context';
import { useShipmentTracking } from 'src/lib/contexts/ShipmentTrackingContext';
import Coachmarks from '../Coachmarks/Coachmarks';
import CouponTab from '../CouponTab';
import FrequentlyAskedQuestions from './FrequentlyAskedQuestions/FrequentlyAskedQuestions';
import { toastAtom } from './OfferList/OfferCard';
import OfferTab from './OfferTab';
import styles from './styles.module.scss';
import WrappedPointHistoryDrawer from './PointHistoryDrawer';
import UserRewardsDigitalCardDrawer from './UserRewardsDigitalCardDrawer';
import ManageFavoritesCard from './ManageFavorites/ManageFavoritesCard';
import RecyclingCartridgeEarningNew from './RecyclingCartridgeEarning/RecyclingCartridgeEarningNew';
import Header from './Header';
import WelcomeScreen from '../RewardsEnrollment/WelcomeScreen';

const Tab = withStyles(() => ({
    root: {
        fontSize: 18,
        textTransform: 'none',
        fontFamily: 'StaplesNormsRegular',
        '&$selected': {
            fontFamily: 'StaplesNormsBold',
        },
    },
    selected: {},
}))((props: { label: string }) => <MUITab {...props} />);

const useStyles = makeStyles({
    screen: {
        flexGrow: 1,
        background: COLORS.whiteSmoke,
    },
    paperDrawer: {
        borderRadius: ' 15px 15px 0px 0px',
        margin: '0',
    },
});

function EasyRewards() {
    const classes = useStyles();

    const homePageCMSURL = process.env.REACT_APP_DOT_COM_URL;
    const weeklyAdsQuikLink = `${process.env.REACT_APP_DOT_COM_URL}/deals/Staples-Daily-Deals/SEGDD0000001 -ad`;
    const coachmarks: any = localStorage?.getItem('coachmarks');
    const parseCoachmarks = JSON.parse(coachmarks);
    const [coachmarksData, setCoachmarksData] = useState(parseCoachmarks);
    const scrollContainerRef = useRef<HTMLElement | null>(null);
    const bottomSectionRef = useRef<HTMLDivElement | null>(null);
    const offerRef = useRef<HTMLDivElement | null>(null);
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const { isGuestModeOn } = useGuestMode();
    const { setShowTooltip } = useErTooltips();
    const { addNotification } = useStickyNotification();
    const history = useHistory();
    const [toastMessage, setToastMessage] = useAtom(toastAtom);
    const { userInfo, isFetchingUserInfo, refetchUserInfo } = useUserInfo();
    const { query, push, location, pathname } = useRouter();

    const shouldActivateAllOffers = useMemo(() => {
        const locationState = location.state as any;
        return !!locationState?.activateAll || query?.activateAllOffers;
    }, []);
    const [enrollmentError, setEnrollmentError] = useState<{
        errorCode: string;
        errorDialogMessage: string;
    } | null>(null);

    const { analyticsCustomEvent } = useEventsReporter();

    const { mutateAsync: enroll } = useEnrollInRewardsMutation({
        onSuccess: () => refetchUserInfo(),
    });
    const rewardsNumber = userInfo?.rewardsNumber || '';
    // TODO Remove all coupon logic from this component and move it to it's own component.
    // Use this component only to consolidate all the sections of the easy rewards page.
    // Do not use this component to write any logic which can be isolated in its own component.

    const tabIndex = parseInt(query?.tabIndex, 10) || 1;
    const [activeTabIndex, setActiveTabIndex] = useState(tabIndex);
    const [tosSource, setTosSource] = useState<string | null>(null);
    const [showTabs, setShowTabs] = useState(false);
    const [tosTabIndex, setTosTabIndex] = useState(0);
    const [isCouponsFetchingError, setCouponsFetchingError] = useState(false);

    const [available, setAvailable] = useState<any[]>([]);
    const [saved, setSaved] = useState<any[]>([]);
    const [redeemed, setRedeemed] = useState<any[]>([]);
    const [isIframeScrolled, setIsIframeScrolled] = useState(false);
    const [isViewAllOffers, setIsViewAllOffers] = useState(false);
    const [isViewAllMassOffers, setIsViewAllMassOffers] = useState(false);
    const [isOpenIframe, setIsOpenIframe] = useState(false);
    const [quickLinkUrl, setQuickLinkUrl] = useState('');
    const {
        setHideFooter,
        isPointHistoryDrawerOpen,
        setPointHistoryDrawer,
        hanRewardsWorks,
        isVariantTypePointInfo,
        isUserRewardsDigitalCardDrawerOpen,
        toggleIsUserRewardsDigitalCardDrawerOpen,
    } = useUserUpdateContext();
    const {
        storeServicesLink,
        setStoreServicesLink,
        storeLocatorUrl,
        setStoreLocatorUrl,
        homeLinkInNative,
        setHomeLinkInNative,
        dotComUrl,
        setDotComUrl,
        cartPage,
        printPage,
        handleSetCartPage,
        homePage,
        itemPage,
        setPrintPage,
    } = useTabsUIStateContext();
    console.log('isUserRewardsDigitalCardDrawerOpen', isPointHistoryDrawerOpen);
    const { setGoBackRoute, goBackRoute } = useShipmentTracking();
    const { setShoppingType } = useProductBrowseContext();
    const [isOpenUnclipModal, setIsOpenUnclipModal] = useState(false);
    const [value, setValue] = useState(0);
    const { isStoreModeOn } = useStoreData();

    const [heroCoupon, setHeroCoupon] = useState<any>({});
    const viewcoupon = localStorage.getItem('viewcoupon');

    const { data: isSaveCouponsEnabled } = useQuery(
        ['isSaveCouponsEnabled'],
        () => isListEnabled('SaveCoupons'),
        {
            refetchOnMount: true,
        }
    );
    const {
        data: loyaltyAccountDetails,
        isLoading: isLoyaltyAccountDetailsLoading,
    } = useLoyaltyAccountDetailsQuery({
        rewardsNumber: userInfo?.rewardsNumber,
        config: {
            enabled: !!userInfo?.rewardsNumber,
            refetchOnMount: false,
        },
    });

    const {
        data: couponResponse,
        refetch: refetchCoupons,
        isFetching: isCouponDataFetching,
    } = getCoupons({
        rewardsNumber,
        config: {
            onError: (error) => {
                setCouponsFetchingError(true);
                console.log(error, 'loyaltyerror');
                // setLoading(false);
            },
        },
    });

    const lifetimeValue = useMemo(
        () =>
            loyaltyAccountDetails?.accounts[0]?.walletinfo?.balances?.lifetime,
        [loyaltyAccountDetails]
    );
    const rewardstiercode = useMemo(
        () => loyaltyAccountDetails?.accounts[0]?.rewardstiercode,
        [loyaltyAccountDetails]
    );
    const queryClient = useQueryClient();

    // TODO fix variable type
    const handleExtendCouponDate = (offer: any) => {
        // TODO use react query to write the service call
        saveDigitalCoupon({
            rewardsNumber,
            // couponCode: 0,
            couponCode: offer?.couponNumber,
            isSaved: !offer?.couponInfo?.isSaved,
        })
            .then((couponRes) => {
                const data = couponRes?.data?.couponDataList;

                const newCouponData = couponRes?.data;
                queryClient.setQueryData(
                    [GET_COUPONS_QUERY_KEY, rewardsNumber],
                    newCouponData
                );
                setAvailable(
                    data?.filter(
                        (item: any) =>
                            item?.couponInfo?.isNewCoupon &&
                            !item?.couponInfo?.isRedeemed
                    )
                );
                setSaved(
                    data?.filter(
                        (item: any) =>
                            item?.couponInfo?.isSaved &&
                            !item?.couponInfo?.isRedeemed
                    )
                );
                setRedeemed(
                    data?.filter((item: any) => item?.couponInfo?.isRedeemed)
                );
                setIsOpenUnclipModal(false);
            })
            .catch(() => {
                setIsOpenUnclipModal(true);
            });
    };

    const handleToggleIndex = (index: number, isScrollToTop = false) => {
        setCouponsFetchingError(false);
        // getCouponData();
        setActiveTabIndex(index);
        if (isScrollToTop && scrollContainerRef?.current) {
            scrollContainerRef.current.scroll({ top: 0 });
        }
    };

    const scrollToFirstOffer = useCallback(() => {
        if (offerRef?.current) {
            offerRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    useEffect(() => {
        if (activeTabIndex === 1) {
            setCouponsFetchingError(false);
            analyticsCustomEvent(eventMetricsMap.screen_view, {
                firebase_screen: `app_easy rewards earn points`,
                firebase_screen_class: `app_easy rewards earn points`,
            });
            // refetchLoyaltyOffers();
        } else {
            analyticsCustomEvent(eventMetricsMap.screen_view, {
                firebase_screen: `app_easy rewards store coupons`,
                firebase_screen_class: `app_easy rewards store coupons`,
            });
        }
    }, [activeTabIndex]);

    useEffect(() => {
        if (couponResponse) {
            const data = couponResponse?.couponDataList;
            const filterHeroCoupon = data.find(
                (item: any) =>
                    item?.category === 'Coupon' &&
                    item?.couponInfo?.isNewCoupon &&
                    !item?.couponInfo?.isRedeemed &&
                    item?.couponInfo?.offerType === 'Hero'
            );
            if (filterHeroCoupon?.couponInfo) {
                setHeroCoupon(filterHeroCoupon);
            } else if (data.length > 0) {
                setHeroCoupon(
                    data.find((coupon: any) => !coupon?.couponInfo?.isRedeemed)
                );
            }
            const filterCouponData = data
                .filter((coupon: any) => coupon.category === 'Coupon')
                .sort(
                    (a: any, b: any) =>
                        a.couponInfo.priority - b.couponInfo.priority
                );

            setAvailable(
                filterCouponData?.filter(
                    (item: any) =>
                        item?.couponInfo?.isNewCoupon &&
                        (!item?.couponInfo?.isRedeemed ||
                            item?.couponInfo?.couponClass.toLowerCase() ===
                                'storecredit')
                )
            );
            setSaved(
                filterCouponData?.filter(
                    (item: any) =>
                        item?.couponInfo?.isSaved &&
                        !item?.couponInfo?.isRedeemed
                )
            );
            setRedeemed(
                filterCouponData?.filter(
                    (item: any) => item?.couponInfo?.isRedeemed
                )
            );
            if (!couponResponse?.success) {
                setCouponsFetchingError(true);
            }
        }
    }, [couponResponse]);

    useEffect(() => {
        if (viewcoupon === 'true') {
            localStorage.setItem('viewcoupon', 'false');
            setActiveTabIndex(2);
        }
    }, [viewcoupon]);

    //  show tos notification if user hasn't accepted them
    useEffect(() => {
        if (
            userInfo?.rewardsNumber &&
            !isLoyaltyAccountDetailsLoading &&
            loyaltyAccountDetails?.accounts[0]?.termsandconditionaccepted ===
                'N'
        ) {
            addNotification({
                id: 'loyaltyTOSNotification',
                group: 'loyaltyTOS',
            });
        }
    }, [isLoyaltyAccountDetailsLoading, isFetchingUserInfo]);

    useEffect(() => {
        if (loyaltyAccountDetails) {
            const loyaltyAccounts = loyaltyAccountDetails.accounts;
            if (loyaltyAccounts.length) {
                const walletInfo = loyaltyAccounts[0].walletinfo;
                if (walletInfo && Object.keys(walletInfo).length) {
                    const walletBalance = walletInfo.balances;
                    if (walletBalance.lifetime >= 5000) {
                        setShowTooltip('categoriesTooltip');
                    }
                }
            }
        }
    }, [loyaltyAccountDetails]);

    useEffect(() => {
        if (isViewAllOffers || isViewAllMassOffers) {
            scrollContainerRef?.current?.scroll({ top: 0 });
        }
    }, [isViewAllOffers, isViewAllMassOffers]);

    const handleMassOfferBack = () => {
        setIsViewAllMassOffers(false);
        setTimeout(() => {
            document
                ?.getElementById?.('view-all-id-for-offer')
                ?.scrollIntoView(true);
        }, 500);
        setHideFooter(false);
    };

    const handleAllOfferBack = () => {
        setIsViewAllOffers(false);
        setTimeout(() => {
            document?.getElementById?.('your-offer-id')?.scrollIntoView(false);
        }, 500);
        setHideFooter(false);
    };

    useEffect(() => {
        if (isViewAllOffers || isViewAllMassOffers) {
            const unblock = history.block(() => {
                // eslint-disable-next-line no-unused-expressions
                isViewAllOffers ? handleAllOfferBack() : handleMassOfferBack();
                return false;
            });

            return () => {
                unblock();
            };
        }
        return undefined;
    }, [isViewAllOffers, isViewAllMassOffers]);

    useEffect(() => {
        if (
            activeTabIndex === 2 &&
            ((userInfo && !userInfo.rewardsNumber) || isGuestModeOn)
        ) {
            analyticsCustomEvent(eventMetricsMap.screen_view, {
                firebase_screen: `easyrewards tab_unenrolled coupons`,
                firebase_screen_class: `easyrewards tab_unenrolled coupons`,
            });
        }
    }, [activeTabIndex, userInfo?.rewardsNumber]);

    useEffect(() => {
        setHideFooter(false);
        setShowTooltip('activateOfferTooltip');
        refetchCoupons();
        if ((userInfo && userInfo.rewardsNumber) || isGuestModeOn) {
            analyticsCustomEvent(eventMetricsMap.screen_view, {
                firebase_screen: 'app_easy rewards',
                firebase_screen_class: 'app_easy rewards',
            });
        }
        return () => setHideFooter(false);
    }, []);

    const iframeHeight = useMemo(() => {
        const baseHeight = 'calc(100vh - 76px)';

        return isStoreModeOn ? `calc(${baseHeight} - 66px)` : baseHeight;
    }, [isStoreModeOn]);

    const handleOnIframeScroll = (event: Event) => {
        const target = event?.currentTarget as any;
        const scrollTop = target?.scrollY;
        if (scrollTop >= 50) {
            setIsIframeScrolled(true);
        } else if (scrollTop < 50) {
            setIsIframeScrolled(false);
        }
    };

    const refreshWebView = () => {
        SetSomniAppCookies();
        const documentData: any = document?.getElementById?.(
            'shopping-online-screen-iframe'
        );
        if (documentData?.src) {
            documentData.src = homePageCMSURL;
        }
        setTimeout(() => {
            const iframe = iframeRef?.current;
            if (iframe) {
                const iframeContentWindow = iframe?.contentWindow;
                iframeContentWindow?.removeEventListener(
                    'scroll',
                    handleOnIframeScroll,
                    true
                );
                iframeContentWindow?.addEventListener(
                    'scroll',
                    handleOnIframeScroll,
                    true
                );
            }
        }, 1000);
    };

    const handleClickOnBackBtnOnline = () => {
        refreshWebView();
        if (storeServicesLink) {
            setStoreServicesLink('');
        }
        handleSetCartPage(false);
        if (quickLinkUrl) {
            setQuickLinkUrl('');
        }
    };

    const onWeeklyAdsClick = () => {
        setGoBackRoute(undefined);
        setQuickLinkUrl(weeklyAdsQuikLink);
    };

    if ((userInfo && !userInfo.rewardsNumber) || isGuestModeOn) {
        return <WelcomeScreen variant="easy-rewards" />;
    }

    return (
        <>
            {(isFetchingUserInfo || !userInfo) && !isGuestModeOn ? (
                <div style={{ height: '0vh' }}></div>
            ) : null}

            <PullToRefresh
                onRefresh={async () =>
                    Promise.all([
                        queryClient.invalidateQueries({
                            queryKey: [LoyaltyOffersQueryKey],
                        }),
                        refetchCoupons(),
                    ])
                }
                bgColor="bgPurple"
                scrollContainerRef={scrollContainerRef}
            >
                <BackToTopFAB
                    containerRef={scrollContainerRef}
                    distanceToTop="10rem"
                    bgColor={activeTabIndex === 1 ? 'bgPurple' : 'bgRed'}
                />

                <div className={styles.pbNav}>
                    <Header
                        activeTabIndex={activeTabIndex}
                        containerRef={scrollContainerRef}
                        scrollToFirstOffer={scrollToFirstOffer}
                        handleToggleIndex={handleToggleIndex}
                    />
                    <div
                        style={{
                            backgroundColor: '#f2f2f2',
                        }}
                    >
                        {activeTabIndex === 1 && (
                            <>
                                <Row gap="15px" sx={{ p: '0 1rem 1rem' }}>
                                    <>
                                        <Box className={styles.squerCard}>
                                            <ManageFavoritesCard />
                                        </Box>
                                        <Box className={styles.squerCard}>
                                            <RecyclingCartridgeEarningNew />
                                        </Box>
                                    </>
                                </Row>
                                <OfferTab
                                    offerRef={offerRef}
                                    shouldActivateAllOffers={
                                        shouldActivateAllOffers
                                    }
                                    couponData={heroCoupon}
                                />
                                <FrequentlyAskedQuestions />
                            </>
                        )}
                        {/*  eslint-disable no-nested-ternary  */}
                        {activeTabIndex === 2 &&
                        (available.length ||
                            saved.length ||
                            redeemed.length ||
                            isCouponsFetchingError) ? (
                            isCouponDataFetching ? (
                                <Player
                                    autoplay
                                    loop
                                    src={require('../../assets/lotties/stapleRevealWordmark.json')}
                                    style={{ height: '150px' }}
                                />
                            ) : (
                                <>
                                    <CouponTab
                                        available={available}
                                        saved={saved}
                                        isSaveCouponsEnabled={
                                            isSaveCouponsEnabled?.isenabled
                                        }
                                        redeemed={redeemed}
                                        offerActivate={handleExtendCouponDate}
                                        isCouponsFetchingError={
                                            isCouponsFetchingError
                                        }
                                        setValue={setValue}
                                        value={value}
                                    />
                                    {value === 0 && (
                                        <Row
                                            gap="10px"
                                            sx={{
                                                px: '16px',
                                                pb: '16px',
                                            }}
                                        >
                                            <>
                                                <Button
                                                    bgColor="bgRed"
                                                    color="textWhite"
                                                    variant="contained-rounded"
                                                    className={styles.w100}
                                                    onClick={onWeeklyAdsClick}
                                                >
                                                    Weekly ad
                                                </Button>
                                                <Button
                                                    bgColor="bgPurple"
                                                    color="textWhite"
                                                    variant="contained-rounded"
                                                    className={styles.w100}
                                                    onClick={() => {
                                                        setActiveTabIndex(1);
                                                        scrollContainerRef.current?.scroll(
                                                            {
                                                                top: 0,
                                                                behavior:
                                                                    'smooth',
                                                            }
                                                        );
                                                    }}
                                                >
                                                    Easy Rewards
                                                </Button>
                                            </>
                                        </Row>
                                    )}
                                </>
                            )
                        ) : (
                            <>
                                {activeTabIndex === 2 &&
                                    isCouponDataFetching &&
                                    !(
                                        available.length ||
                                        saved.length ||
                                        redeemed.length
                                    ) && (
                                        <Player
                                            autoplay
                                            loop
                                            src={require('../../assets/lotties/stapleRevealWordmark.json')}
                                            style={{ height: '150px' }}
                                        />
                                    )}
                            </>
                        )}
                    </div>
                </div>
            </PullToRefresh>
            <AlertMessage
                open={!!toastMessage}
                icon={<IconStaplesRound />}
                handleClose={() => setToastMessage('')}
                btnName={''}
                message={toastMessage}
                handleBtnClick={() => setToastMessage('')}
                status={''}
            />
            <RewardsEnrollErrorDialog
                error={enrollmentError}
                setError={setEnrollmentError}
            />
            <SwipeableDrawer
                anchor="bottom"
                open={!!tosSource}
                onClose={() => {
                    setTosSource(null);
                    setShowTabs(false);
                }}
                onOpen={() => console.log('open')}
            >
                {showTabs && (
                    <Tabs
                        className={styles.tosTabs}
                        value={tosTabIndex}
                        onChange={(_e, val) => setTosTabIndex(val)}
                        aria-label="simple tabs example"
                    >
                        <Tab label="Staples" />
                        <Tab label="Easy Rewards" />
                    </Tabs>
                )}
                {tosTabIndex === 0 && (
                    <iframe
                        id="privacy-link"
                        title="privacy link iFrame"
                        style={{
                            height: '90vh',
                            width: '100%',
                            marginTop: 16,
                        }}
                        src={tosSource || '#'}
                    />
                )}
                {tosTabIndex === 1 && (
                    <iframe
                        id="privacy-link"
                        title="privacy link iFrame"
                        style={{
                            height: '90vh',
                            width: '100%',
                            marginTop: 16,
                        }}
                        src={tosSource || '#'}
                    />
                )}
            </SwipeableDrawer>
            {coachmarksData?.completed === false && userInfo?.rewardsNumber ? (
                <Coachmarks
                    coachmarksData={coachmarksData}
                    setCoachmarksData={setCoachmarksData}
                />
            ) : null}
            {isOpenUnclipModal && (
                <CommonModal open={isOpenUnclipModal} isNoPadding>
                    <Row
                        direction="column"
                        gap="30px"
                        sx={{
                            px: '27px',
                            py: '16px',
                            position: 'relative',
                        }}
                    >
                        <>
                            <Box>
                                <>
                                    <Box
                                        sx={{
                                            pt: '14px',
                                            pb: '5px',
                                        }}
                                    >
                                        <Body
                                            size={18}
                                            lineHeight={22}
                                            textAlign="textCenter"
                                        >
                                            Unable to clip coupon
                                        </Body>
                                    </Box>
                                    <Box>
                                        <Body
                                            size={14}
                                            lineHeight={20}
                                            weight="light"
                                            textAlign="textCenter"
                                        >
                                            We couldn’t clip the coupon at this
                                            time.
                                        </Body>
                                        <Body
                                            size={14}
                                            lineHeight={20}
                                            weight="light"
                                            textAlign="textCenter"
                                        >
                                            Please try again later.
                                        </Body>
                                    </Box>
                                </>
                            </Box>

                            <Button
                                className={styles.gotItBtn}
                                onClick={() => setIsOpenUnclipModal(false)}
                            >
                                Got it
                            </Button>
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 8,
                                    right: 5,
                                }}
                            >
                                <IconButton
                                    style={{
                                        color: 'inherit',
                                        padding: 0,
                                    }}
                                    onClick={() => setIsOpenUnclipModal(false)}
                                >
                                    <CancelRounded />
                                </IconButton>
                            </Box>
                        </>
                    </Row>
                </CommonModal>
            )}

            {isPointHistoryDrawerOpen && (
                <WrappedPointHistoryDrawer
                    open={isPointHistoryDrawerOpen}
                    setOpen={setPointHistoryDrawer}
                    variant={
                        lifetimeValue &&
                        lifetimeValue > 0 &&
                        !isVariantTypePointInfo
                            ? 'points-history'
                            : 'points-info'
                    }
                    hanRewardsWorks={hanRewardsWorks}
                />
            )}
            <UserRewardsDigitalCardDrawer
                open={isUserRewardsDigitalCardDrawerOpen}
                toggleOpen={toggleIsUserRewardsDigitalCardDrawerOpen}
                rewardstiercode={rewardstiercode ?? ''}
            />
            <Drawer
                open={quickLinkUrl.length > 0}
                onClose={() => setQuickLinkUrl('')}
                classes={{
                    paper: classes.paperDrawer,
                }}
            >
                <Box className={mergeClasses(classes.screen)}>
                    <IframeHeader
                        position="fixed"
                        headerFull={!quickLinkUrl}
                        backButton={
                            (!!quickLinkUrl || !homePage) &&
                            pathname === ROUTES.rewardsWallet
                        }
                        onClickHandler={handleClickOnBackBtnOnline}
                    />
                    <Box
                        style={{
                            paddingTop: '70px',
                        }}
                    >
                        <BrandIframe
                            src={quickLinkUrl}
                            title="Shopping-online-screen-wallet"
                            id="sShopping-online-screen-wallet"
                            iframeRef={iframeRef}
                            height={iframeHeight}
                        />
                    </Box>
                </Box>
            </Drawer>
        </>
    );
}

export default EasyRewards;
